import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { operationRecordsUrl,signUrl } = Urls;

const path = name => `app/pages/operationRecords/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    erroTip:{
        data: [
            { label: '跳出率', value: '跳出率',key: 0 },
            { label: '停留时间', value: '停留时间',key: 1 },
            { label: 'SIVT', value: 'SIVT',key : 2},
            { label: '无曝光点击', value: '无曝光点击',key : 3},
            { label: 'CTR异常', value: 'CTR异常',key : 4},
            { label: '来源异常', value: '来源异常',key : 5},
            { label: '曝光碰撞', value: '曝光碰撞',key : 6},
            { label: '代理故障', value: '代理故障',key : 7},
        ],
        handlers: {
            getErroTip(state, action) {
                return action.payload;
            },
            addErroTip(state, action) {
                return [
                    ...state,
                    ...action.payload,
                ];
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {
           // beginTime: moment().format('YYYY-MM-DD'),
            //endTime: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelect: {
        data: {},
        handlers: {
            changeCurrentSelect(state, action) {
                return action.payload;
            },
        },
    },
    allMonitorName: {
        data: [],
        handlers: {
            getList(state, action) {
                return action.payload;
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().operationRecords;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};




/**
 * 获取operationRecords数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(operationRecordsUrl.getOperationRecordsList, 'POST', formatGetParams(getState));
            result.list.map(item => {
                item.key = item.index;
                return item;
            });
            dispatch(actions.get(result.list));
            dispatch(actions.changePagination({totalPage: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncGetTaskInfo = (record, type) => {
    return async (dispatch, getState) => {
        try {
            if (type) {
                dispatch(
                    actions.changeUiStatus({
                        isLoading: true,
                    }),
                );
                // 下面的请求和结果返回需要根据接口来实现
                let result = await request(signUrl.getEveryDayCheckInfo, 'POST', {pricple: record.pricple});
                record.taskList = result;
            }
            dispatch(actions.changeCurrentSelect({record, type}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

/**
 * 获取订单列表数据
 */
export const asyncGetallMonitorName = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(operationRecordsUrl.allMonitorNameUrl, 'GET');
            dispatch(actions.getList(result));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

export const asyncUpdate = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(operationRecordsUrl.editOperationRecords, 'POST', contents);
            message.success('修改成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const asyncAdd = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(operationRecordsUrl.addOperationRecords, 'POST', contents);
            message.success('添加成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

export const delect = record => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(operationRecordsUrl.delOperationRecords, 'POST', record);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};






// WEBPACK FOOTER //
// ./pages/sign/operationRecords/reducers.js